import React from 'react';
import ReactDOM from 'react-dom';
import DataGatheringBanner from '../../src/components/react/data_gathering_banner/bootstrap_3/data_gathering_banner';
import DevexHighOrderComponent from '../../src/components/react/devex_high_order_component/devex_high_order_component';

document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('data-gathering-banner');
  if (!root) return;

  ReactDOM.render(
    <DevexHighOrderComponent>
      <DataGatheringBanner requestedField={JSON.parse(root.dataset.requestedField)} />
    </DevexHighOrderComponent>,
    root
  );
});
